import { IModalActionPayload, setModal } from "../state/slices/modalSlice";
import { useAppDispatch } from "./reduxHooks";

export default function useModal() {
  const dispatch = useAppDispatch();
  return (args: false | IModalActionPayload) => dispatch(setModal(args));
}